const typography = {
  fontFamily: 'Archivo, sans-serif',
  h1: {
    fontSize: 60,
    fontWeight: 500,
  },
  h1_A: {
    fontSize: 34,
    fontWeight: 500,
    fontFamily: 'Archivo, sans-serif',
  },
  h2: {
    fontSize: 26,
    fontWeight: 500,
  },
  h3: {
    fontSize: 23,
    fontWeight: 500,
    letterSpacing: 0.5,
  },
  h4: {
    fontSize: '18px',
    fontWeight: 500,
    letterSpacing: 0.5,
  },
  h5: {
    fontSize: 16,
    fontWeight: 500,
    letterSpacing: 0.3,
  },
  h5_1: {
    fontSize: 17,
    fontWeight: 500,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: 0.2,
  },
  h5_2: {
    fontSize: 14,
    fontWeight: 600,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: 0.3,
  },
  h6: {
    fontSize: 13,
    fontWeight: 500,
    letterSpacing: 0.3,
  },
  h7: {
    fontSize: 12,
    fontWeight: 500,
    letterSpacing: 0.4,
    fontFamily: 'Archivo, sans-serif',
  },
  subtitle1: {
    fontSize: 17,
    lineHeight: 1.25,
  },
  /** Semantic variants — describe use-case, not size */
  sectionTitle: {
    fontSize: 22,
    fontWeight: 700,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: '2%',
  },
  tableCell: {
    fontSize: 15,
    fontWeight: 500,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: '2%',
  },
  balance: {
    fontSize: 60,
    fontWeight: 500,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: '5%',
  },
  caption: {
    fontSize: 12,
    fontWeight: 400,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: 0.3,
  },
  notificationTitle: {
    fontSize: 12,
    fontWeight: 500,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: '0%',
  },
  notificationBody: {
    fontSize: 10,
    fontWeight: 400,
    fontFamily: 'Archivo, sans-serif',
    letterSpacing: '0.5px',
  },
};

export default typography;

